export default __webpack_public_path__ + "static/media/hht2_ep_02.b379ed3f.png";